module.exports = __webpack_public_path__ + "static/media/buy_report_service_3.c582e71d.png";